// extracted by mini-css-extract-plugin
var _1 = "dFxNGSSXCzz0ymjryEPB";
export { _1 as "layout" }
